module.exports = __webpack_public_path__ + "media/src/images/raffleCheckboxCheckmark--light-8c6ec44a925652262e536ec6e73bf45d.svg";